import { ReactElement } from "react";

interface DecisionBarProps {
  enabled: boolean;
  /** Missing requirements; approval is blocked while any remain. */
  approveErrors: string[];
  onApprove: () => void;
  onReject: () => void;
}

/** Approve / return actions. Disabled unless the record awaits a decision. */
const DecisionBar: React.FC<DecisionBarProps> = ({
  enabled,
  approveErrors,
  onApprove,
  onReject,
}): ReactElement => (
  <div className="panel">
    <div className="actions">
      {/* Saying what is missing beats a button that is simply dead. */}
      <span className={approveErrors.length > 0 && enabled ? "hint is-blocked" : "hint"}>
        {approveErrors.length > 0 && enabled
          ? approveErrors.join(" ")
          : "Approving generates and delivers the final document. Returning sends it back to the client with your feedback."}
      </span>
      <button
        type="button"
        className="btn reject"
        disabled={!enabled}
        onClick={onReject}
      >
        Return to client
      </button>
      <button
        type="button"
        className="btn approve"
        disabled={!enabled || approveErrors.length > 0}
        onClick={onApprove}
      >
        Approve
      </button>
    </div>
  </div>
);

export default DecisionBar;
